import Vue from 'vue'
import { contractAbis } from '@/constants/abis'
import { getMainPoolsStats, getCryptoPoolsStats } from '@/utils/stats';
import config from '@/constants/config'
import pools, { poolIds } from '@/constants/pools'
import BN from 'bignumber.js'
import REFERENCE_ASSETS from '@/constants/reference-assets.js';
import getPoolUsdFigure from '@/utils/data/getPoolUsdFigure';
import * as helpers from '@/utils/helpers'
import getPricesForAssets from '../../utils/data/getPricesForAssets';

const getPool = (id) => pools.getById((
    id == 'susd' ? 'susdv2' : id
));

const normalizedPoolIds = poolIds.map((id) => (
    id === 'iearn' ? 'y' :
        id === 'susdv2' ? 'susd' : id
));

// { compound: [], usdt: [], … }
let initState = () => helpers.arrayToHashmap(normalizedPoolIds.map((id) => [id, []]));

export const state = Vue.observable({
    volumes: {
        ...Object.fromEntries(Object.entries(initState()).map(([key, el]) => [key, [-1, -1]]))
    },
    volumeData: {
        5: {
            ...initState()
        },
        30: {
            ...initState()
        },
        1440: {
            ...initState()
        }
    },
    allVolume: {
        ...initState()
    }
})

export function findClosestPrice(timestamp, data) {
    let result = data.find(d => Date.parse(d[0]) / 1000 - timestamp > 0);
    if (result === undefined) return data[data.length - 1][1]
    return result.price
}


export async function fetchVolumeData(paramPools, refresh = false, period = 5) {
    if (!Array.isArray(paramPools)) paramPools = [paramPools];
    const unnormalizedPoolIds = paramPools;
    paramPools = paramPools.map(p => p == 'iearn' ? 'y' : p == 'susdv2' ? 'susd' : p == 'ren2' ? 'ren' : p == 'rens' ? 'sbtc' : p)
    if (!refresh) paramPools = paramPools.filter(pool => !state.volumeData[period][pool].length)
    //paramPools = paramPools.filter(pool => !['tbtc'].includes(pool))
    let requests = paramPools.map(p => {
        const pool = getPool(p);

        if (config.blockchainId === 'ethereum' && p == 'ren') p = 'ren2'
        if (p == 'sbtc') p = 'rens'

        const rawStatsPath = pool.cryptoPool ?
            `${config.rawStatsPath}-crypto` :
            config.rawStatsPath;

        return fetch(`${window.domain}/${rawStatsPath}/${p}-${period}m.json`)
    })

    //will work for 17 days on 5 minutes chart
    const poolsContainBtcPools =
        unnormalizedPoolIds.some((poolId) => getPool(poolId).referenceAsset === REFERENCE_ASSETS.BTC);

    if (poolsContainBtcPools) {
        requests.push(fetch(`
			https://api.coingecko.com/api/v3/coins/bitcoin/market_chart/range?vs_currency=usd&from=1589587198&to=${(Date.now() / 1000) | 0}`
        ))
    }
    requests = await Promise.all(requests)
    let jsons = await Promise.all(requests.map(r => r.json()))
    let btcPrices = jsons[jsons.length - 1]
    if (poolsContainBtcPools) jsons = jsons.slice(0, -1)
    for (let [i, data] of jsons.entries()) {
        let pool = pools[i];
        if (getPool(unnormalizedPoolIds[i]).referenceAsset === REFERENCE_ASSETS.BTC) {
            data = data.map(d => {
                d.volume = Object.fromEntries(Object.entries(d.volume).map(([k, v]) => [k, v.map(vol => vol * findClosestPrice(d.timestamp, btcPrices.prices))]))
                return d;
            })
        }
        state.volumeData[period][pool] = data
    }
}

export async function getVolumes(pools, refresh = false) {

    if (!Array.isArray(pools)) pools = [pools]
    pools = pools.map(p => p == 'iearn' ? 'y' : p == 'susdv2' ? 'susd' : p == 'ren' ? 'ren2' : p == 'sbtc' ? 'rens' : p)
    if (Object.values(state.volumes).filter(v => v[0] != -1).length == pools.length && !refresh) return;

    const btcPrice = (await getPricesForAssets(['bitcoin']))['bitcoin'];
    let stats = await getMainPoolsStats();




    let cryptoStats = null
    if (config.blockchainId == 'ethereum') {
        cryptoStats = await getCryptoPoolsStats();
    }
    if (config.blockchainId !== 'ethereum') {
        cryptoStats = await getMainPoolsStats();
    }


    btcPrice = btcPrice.bitcoin.usd
    //console.log(btcPrice);
    //eurPrice = btcPrice["stasis-eurs"].usd
    for (let [pool, volume] of Object.entries(state.volumes)) {

        if (volume[0] == -1) {


            let volume = (config.blockchainId === 'ethereum' && pool == 'ren') ? stats.volume.ren2 : pool == 'sbtc' ? stats.volume.rens : stats.volume[pool]
            const normalizedPoolId = (
                pool === 'y' ? 'iearn' :
                    pool === 'susd' ? 'susdv2' : pool
            );
            volume = await getPoolUsdFigure(volume, getPool(normalizedPoolId));
            if (cryptoStats && cryptoStats.volume[pool]) {
                volume = cryptoStats.volume[pool]
                stats.volume[pool] = volume

            }

            Vue.set(state.volumes[pool], 0, volume || 0)
            Vue.set(state.volumes[pool], 1, (config.blockchainId === 'ethereum' && pool == 'ren') ? stats.volume.ren2 : pool == 'sbtc' ? stats.volume.rens : stats.volume[pool])
        }
    }


}

export async function getDailyVolume(pool, refresh = false, interval = 30) {

    pool = pool == 'iearn' ? 'y' : pool == 'susdv2' ? 'susd' : pool
    if (state.allVolume[pool].length && !refresh) return;
    await fetchVolumeData(pool, refresh, interval)
    let json = state.volumeData[interval][pool];
    state.volumeData[pool] = json
    for (let data of json) {
        state.allVolume[pool].push([
            data.timestamp * 1000,
            Object.entries(data.volume).map(([k, v]) => {
                let precisions = contractAbis[pool == 'susd' ? 'susdv2' : pool].coin_precisions[k.split('-')[0]]
                return v[0] / precisions
            }).reduce((a, b) => a + b, 0)
        ])
    }
}


export async function getLendingAPY(pool, refresh = false, interval = 30) {
    pool = pool == 'iearn' ? 'y' : pool == 'susdv2' ? 'susd' : pool
    if (!state.volumeData[interval][pool].length)
        await fetchVolumeData(pool, refresh, interval)

    let lendingrates = []

    for (let j = 1; j < state.volumeData[interval][pool].length; j++) {
        let json = state.volumeData[interval][pool]
        let data = json[j]
        let prevdata = json[j - 1]
        let balances = data.balances.map((b, bi) => b /= contractAbis[pool == 'susd' ? 'susdv2' : pool].coin_precisions[bi])
        let apdrate = data.rates.map((rate, k) => {
            return (rate / prevdata.rates[k]) - 1
        })
        let balancesp = balances.map((b, bi) => b *= apdrate[bi])
        let sump = balancesp.reduce((a, b) => a + b, 0)
        let sumbalances = balances.reduce((a, b) => a + b, 0)
        let apd = sump / sumbalances
        let daylen = data.timestamp - prevdata.timestamp
        let apdy = (1 + apd) ** (365 * 86400 / daylen)
        lendingrates.push([
            data.timestamp * 1000,
            (apdy - 1) * 100
        ])
    }

    return lendingrates;

}

export function totalVolume() {
    let volume = BN(0);
    for (let vol of Object.values(state.volumes)) {
        volume = volume.plus(BN(vol[0]))
    }
    return volume
}

export async function factoryVolume() {
    const hasFactoryRegistry = !!config.factoryV2RegistryAddress;
    if (!hasFactoryRegistry) return 0;

    let req = await helpers.retry(fetch(`https://api.curve.finance/api/getFactoryAPYs`), 300);
    let res = await req.json();
    return res.data.totalVolume
}

export async function factoryV2Volume() {
    const hasFactoryRegistry = !!config.factoryV2RegistryAddress;
    if (!hasFactoryRegistry) return 0;

    let req = await helpers.retry(fetch(config.factoryV2ApyEndpoint), 300);
    let res = await req.json();
    return res.data.totalVolume
}

export async function factoryV2Volumes() {
    const hasFactoryRegistry = !!config.factoryV2RegistryAddress;
    if (!hasFactoryRegistry) return [];

    let req = await helpers.retry(fetch(config.factoryV2ApyEndpoint), 300);
    let res = await req.json();
    return res.data.poolDetails
}

export async function factoryCryptoVolume() {
    const hasFactoryRegistry = !!config.factoryCryptoRegistryAddress;
    if (!hasFactoryRegistry) return 0;

    let req = await helpers.retry(fetch(config.factoryCryptoApyEndpoint), 300);
    let res = await req.json();
    return res.data.totalVolume
}

export async function factoryCryptoVolumes() {
    const hasFactoryRegistry = !!config.factoryCryptoRegistryAddress;
    if (!hasFactoryRegistry) return [];

    let req = await helpers.retry(fetch(config.factoryCryptoApyEndpoint), 300);
    let res = await req.json();
    return res.data.poolDetails
}
